import { TFunction } from 'i18next';
import { IndividualMemberDto, VignetteStatus } from '../types/member';
import { normalizeEnumValue } from './enumNormalize';

export function resolveVignetteStatus(member: IndividualMemberDto | null | undefined): VignetteStatus {
  if (!member) return VignetteStatus.NotSent;
  if (member.vignetteStatus !== undefined && member.vignetteStatus !== null) {
    return normalizeEnumValue(VignetteStatus, member.vignetteStatus, VignetteStatus.NotSent);
  }
  return VignetteStatus.NotSent;
}

export function getVignetteStatusLabel(status: VignetteStatus, t: TFunction): string {
  switch (status) {
    case VignetteStatus.NotSent:
      return t('vignette.notSent');
    case VignetteStatus.SentByMail:
      return t('vignette.sentByMail');
    case VignetteStatus.ReceivedInPerson:
      return t('vignette.receivedInPerson');
    default:
      return t('vignette.notSent');
  }
}

export function getVignetteDeliveryLabel(status: VignetteStatus, t: TFunction): string {
  switch (status) {
    case VignetteStatus.SentByMail:
      return t('vignette.delivery.byMail');
    case VignetteStatus.ReceivedInPerson:
      return t('vignette.delivery.inPerson');
    default:
      return t('vignette.delivery.notSent');
  }
}

export function isVignetteSent(status: VignetteStatus): boolean {
  return status === VignetteStatus.SentByMail || status === VignetteStatus.ReceivedInPerson;
}
